import { Box, Container, Typography, Paper, Grid, IconButton, Divider, Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ViewBeforePurchase = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)',
      py: { xs: 4, md: 8 },
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 0% 0%, rgba(92,15,47,0.05) 0%, transparent 50%)',
        zIndex: 0
      }
    }}>
      {/* Navigation Buttons */}
      <Box sx={{ position: 'absolute', top: 20, left: 20, zIndex: 10, display: 'flex', gap: 2 }}>
        <IconButton onClick={() => navigate('/')} sx={{ bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: 'white', transform: 'scale(1.1)' }, boxShadow: '0 2px 10px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
          <HomeIcon sx={{ color: '#FF4B91' }} />
        </IconButton>
        <IconButton onClick={() => navigate(-1)} sx={{ bgcolor: 'rgba(255,255,255,0.9)', '&:hover': { bgcolor: 'white', transform: 'scale(1.1)' }, boxShadow: '0 2px 10px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
          <ArrowBackIcon sx={{ color: '#FF4B91' }} />
        </IconButton>
      </Box>
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: { xs: 3, md: 4 },
            borderRadius: '16px',
            background: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'translateY(-5px)'
            }
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 3,
              fontWeight: 700,
              color: '#333',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -10,
                left: 0,
                width: '50px',
                height: '3px',
                background: 'linear-gradient(90deg, #5c0f2f, #7d1f4f)',
                borderRadius: '2px'
              }
            }}
          >
            View Profile Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://source.unsplash.com/random/600x800?portrait"
                alt="Profile"
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '16px',
                  boxShadow: '0 4px 15px rgba(92,15,47,0.1)'
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                gap: 2
              }}>
                <Typography variant="h5" sx={{ fontWeight: 600, color: '#333' }}>
                  John Doe, 28
                </Typography>
                <Typography variant="body1" sx={{ color: '#666' }}>
                  Software Engineer • New York
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2
                }}>
                  <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    borderRadius: '12px',
                    bgcolor: 'rgba(92,15,47,0.05)',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateX(5px)'
                    }
                  }}>
                    <SchoolIcon sx={{ color: '#5c0f2f' }} />
                    <Box>
                      <Typography variant="subtitle2" sx={{ color: '#666' }}>
                        Education
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#333', fontWeight: 600 }}>
                        Bachelor's in Computer Science
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    borderRadius: '12px',
                    bgcolor: 'rgba(92,15,47,0.05)',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateX(5px)'
                    }
                  }}>
                    <WorkIcon sx={{ color: '#5c0f2f' }} />
                    <Box>
                      <Typography variant="subtitle2" sx={{ color: '#666' }}>
                        Occupation
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#333', fontWeight: 600 }}>
                        Software Engineer at Tech Corp
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    borderRadius: '12px',
                    bgcolor: 'rgba(92,15,47,0.05)',
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'translateX(5px)'
                    }
                  }}>
                    <LocationOnIcon sx={{ color: '#5c0f2f' }} />
                    <Box>
                      <Typography variant="subtitle2" sx={{ color: '#666' }}>
                        Location
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#333', fontWeight: 600 }}>
                        New York, USA
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{
                      py: 1.5,
                      background: 'linear-gradient(45deg, #5c0f2f, #7d1f4f)',
                      '&:hover': {
                        background: 'linear-gradient(45deg, #4d0d28, #601233)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 15px rgba(92,15,47,0.3)'
                      },
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      textTransform: 'none',
                      borderRadius: '12px'
                    }}
                  >
                    Purchase Full Profile
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ViewBeforePurchase; 